import { useQuery } from "@tanstack/react-query";
import { getRegions } from "@api/v1/methods";
import { GET_REGIONS_KEY } from "../../cacheKeys";

export const useRegions = () =>
  useQuery({
    queryKey: [GET_REGIONS_KEY],
    queryFn: () => getRegions(),
    staleTime: Infinity,
  });
